import * as React from "react";
import * as instantMessageChannelService from "../../models/services/instantMessageChannelService";
import { Translations } from "ui/Scripts/source/models/translations";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { Base } from "ui/Scripts/source/framework/base";
import { SelectUserDialog } from "../framework/selectUserDialog";
import { IUserListItem, UserListItem } from "../../models/user/userListItem";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { ListLine } from "../framework/listLine";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { IUserState } from "../../models/store/storeTypes";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelUserEditItem";
import { IInstantMessageChannelAddedUser, InstantMessageChannelAddedUser } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddedUser";
import { InstantMessageChannelAddUsersSuccess } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddUsersSuccess";
import { AppUtils } from "../../framework/appUtils";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { SaveDataObj } from "../../framework/saveData";
import { ConfirmationDialogResult, InstantMessageChannelUserActiveState } from "ui/Scripts/source/models/enums";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { CheckBox } from "ui/Scripts/source/components/framework/checkbox";

//InstantMessageChannelUserListMenu
export interface IInstantMessageChannelUserListMenuProp {
    onRemove: () => void;
    onCancel: () => void;
}

export class InstantMessageChannelUserListMenu extends React.Component<IInstantMessageChannelUserListMenuProp, {}> {
    handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className="line" onClick={this.handleRemoveClick}>{Translations.Remove}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//InstantMessageChannelUserListTitleRow
//***************************************************************
export interface IInstantMessageChannelUserListTitleRowProp {
    newChannelUserList: boolean;
}

export class InstantMessageChannelUserListTitleRow extends React.Component<IInstantMessageChannelUserListTitleRowProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="fullLeft lineContainer">
                <div className="line title">
                    <div className="row">
                        {props.newChannelUserList &&
                            <div className="col">
                                <label className="control-label">{Translations.InstantMessageChannelUsers}</label>
                            </div>
                        }
                        {!props.newChannelUserList &&
                            <div className="col">{Translations.InstantMessageChannelUsers}</div>
                        }
                        {!props.newChannelUserList &&
                            <div className="col text-right">{Translations.InstantMessageChannelAdministrator}</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

//InstantMessageChannelUserListCompanyLine
//***************************************************************
export interface IInstantMessageChannelUserListCompanyLineProp {
    company: ICompanyMenuItem;
}

export class InstantMessageChannelUserListCompanyLine extends React.Component<IInstantMessageChannelUserListCompanyLineProp, {}> {
    render() {
        const props = this.props;
        const company = props.company;
        return (<div className="companyLine">
            <div className={"col col-12 flexCont"}>
                {!!company.logo &&
                    <div className="iconCont flex">
                        <img alt="..." src={company.logo} />
                    </div>
                }
                {!!company.logo &&
                    <div className="dataCont flex">
                        <div className="singleLine">{company.name}</div>
                    </div>
                }
                {!company.logo &&
                    <div className="singleLine">{company.name}</div>
                }
            </div>
        </div>);
    }
}

//InstantMessageChannelUserListLine
//***************************************************************
export interface IInstantMessageChannelUserListLineProp {
    instantMessageChannelCompanyId: string;
    isReadOnly: boolean;
    externalChannel: boolean;
    newChannelWizard: boolean;
    user: IInstantMessageChannelEditUserItem;
    selectedId: string;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onSetUserType: (userId: string, userType: number) => void;
}

export class InstantMessageChannelUserListLine extends React.Component<IInstantMessageChannelUserListLineProp, {}> {
    render() {
        const props = this.props;
        const user = props.user;
        return (
            <ListLine
                id={user.id}
                first={false}
                selected={props.selectedId === user.id}
                classes={"line"}
                onClick={props.onClick}
                onLongPress={props.onLongPress}
                onRefreshList={null}>
                <div className="row">
                    <div className="col col-12">
                        {user.getIsInvited() &&
                            <span className="icon pending" title={Translations.WaitingToBeApproved}></span>
                        }
                        {user.getIsRejected() &&
                            <span className="icon rejected" title={Translations.Rejected}></span>
                        }
                        <AvatarImage
                            id={user.userCode}
                            name={user.getName()}
                            image={user.picture}
                        />
                        <div className="dataCont rightAvatar">
                            <div className="singleLine">{user.getName()}</div>
                        </div>
                        {!props.newChannelWizard &&
                            <div className="checkboxCont">
                                {(props.isReadOnly || props.externalChannel && user.companyId !== props.instantMessageChannelCompanyId
                                    ? (user.userType > 0 ? <span className="icon checkmark"></span> : null)
                                    : <CheckBox
                                        title=""
                                        noPadding={true}
                                        checked={user.userType > 0}
                                        disabled={!user.getIsActive()}
                                        onClickBoolean={(checked: boolean) => {
                                            props.onSetUserType(user.id, checked ? 1 : 0);
                                        }}
                                    />
                                )}
                            </div>
                        }
                    </div>
                </div>
            </ListLine>
        );
    }
}

//InstantMessageChannelUserList
//***************************************************************
export interface IInstantMessageChannelUserListProp {
    newChannelWizard?: boolean;
    user: IUserState;
    isReadOnly: boolean;
    instantMessageChannelId: string;
    instantMessageChannelCompanyId: string;
    companies: ICompanyMenuItem[];
    users: IInstantMessageChannelEditUserItem[];
    onRemoved: (ids: string[]) => void;
    onAdded: (companyId :string, users: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[]) => void;
    onUserTypeUpdated: (id: string, userType: number) => void;
}

interface IInstantMessageChannelUserListState {
    // List
    isLoading: boolean;
    users: IInstantMessageChannelEditUserItem[];
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    selectedId: string;
    showListMenu: boolean;

    // Dialog
    showSelectUserDialog: boolean;
}

export class InstantMessageChannelUserList extends React.Component<IInstantMessageChannelUserListProp, IInstantMessageChannelUserListState> {
    getFilteredUsers = (filter: string, column: string, asc: boolean): IInstantMessageChannelEditUserItem[] => {
        const props = this.props;
        let users = props.users ? props.users.slice(0) : [];
        if (filter) {
            const lowFilter = filter.toLowerCase();
            users = users.filter(i => i.userCode.toLowerCase().indexOf(lowFilter) > -1 || i.firstName.toLowerCase().indexOf(lowFilter) > -1 || i.lastName.toLowerCase().indexOf(lowFilter) > -1);
        }
        InstantMessageChannelEditUserItem.sortInstantMessageChannelEditUserItems(users, column, asc);
        return users;
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            users: this.getFilteredUsers("", "code", true),
            filter: "",
            sortColumn: "code",
            sortOrderIsAsc: true,
            selectedId: null,
            showListMenu: false,
            showSelectUserDialog: false,
        };
    }

    filteredList = (filter: string, column: string, asc: boolean) => {
        this.setState({
            filter,
            sortColumn: column,
            sortOrderIsAsc: asc,
            users: this.getFilteredUsers(filter, column, asc),
        });
    };

    componentDidUpdate(prevProps: IInstantMessageChannelUserListProp, prevState: IInstantMessageChannelUserListState) {
        const props = this.props;
        const state = this.state;
        const prevUsersHash = prevProps.users ? prevProps.users.map(i => i.getHash()).join("#") : "";
        const usersHash = props ? props.users.map(i => i.getHash()).join("#") : "";
        if (prevUsersHash === usersHash) return;
        this.filteredList(state.filter, state.sortColumn, state.sortOrderIsAsc);
    }

    //changeFilter = (filter: string) => {
    //    const state = this.state;
    //    this.filteredList(filter, state.sortColumn, state.sortOrderIsAsc);
    //};

    //handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
    //    const state = this.state;
    //    this.filteredList(state.filter, sortColumn, sortOrderIsAsc);
    //};

    //handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
    //    this.setState({
    //        selectedId,
    //        checkedIds
    //    });
    //};
    
    handleLineClick = (id: string) => {
        this.setState({
            selectedId: id
        });
    };

    // #region Set Active User Type
    getSetUserTypeSaveData = (props: IInstantMessageChannelUserListProp, userId: string, userType: number): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", props.instantMessageChannelId);
        result.append("userId", userId);
        result.append("userType", userType);
        return result;
    };

    handleSetUserType = async (userId: string, userType: number) => {
        const props = this.props;
        const users = props.users.map(i => new InstantMessageChannelEditUserItem(i));
        const user = users.find(i => i.id === userId);
        if (!user) return;
        user.userType = userType;
        if (!users.find(i => i.userType > 0.5)) {
            AppUtils.showErrorMessage(Translations.InstantMessageChannelMustHaveAtLeastOneAdministrator);
            return;
        }
        if (userType < 0.5 && user.userCode === props.user.userCode) {
            if (await AppUtils.showConfirmationDialog(Translations.InstantMessageChannelRemoveFromYourselfFromAdministratorsConfirmation) !== ConfirmationDialogResult.Yes) {
                return;
            }
        }
        const saveData = this.getSetUserTypeSaveData(props, userId, userType);
        // Call server
        if (!props.newChannelWizard) {
            const result = await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelEditSetUserType(saveData.obj));
            if (!result) return;
        }
        props.onUserTypeUpdated(userId, userType);
    };
    // #endregion Set Active User Type

    // #region Remove Users
    getRemoveSaveData = (instantMessageChannelId: string, userIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", instantMessageChannelId);
        result.append("userIds", userIds);
        return result;
    };
    
    removeUsersFromInstantMessageChannel = (instantMessageChannelId: string, userIds: string[], showSuccessMessage: boolean = true, disableLoadIndicator: boolean = false): Promise<ApiSuccess> => {
        const saveData = this.getRemoveSaveData(instantMessageChannelId, userIds);
        return AppUtils.callService(() => instantMessageChannelService.instantMessageChannelEditRemoveUsers(saveData.obj), showSuccessMessage, disableLoadIndicator);
    };

    handleRemove = async () => {
        const props = this.props;
        const state = this.state;
        const selectedIds = Base.getSelectedIds(state.selectedId, []);
        if (selectedIds.length < 1) return;
        // Call server
        if (!props.newChannelWizard) {
            const users = props.users.filter(i => selectedIds.indexOf(i.id) < 0);
            if (!users.find(i => i.userType > 0.5)) {
                AppUtils.showErrorMessage(Translations.InstantMessageChannelMustHaveAtLeastOneAdministrator);
                return;
            }
            // Call server
            const result = await this.removeUsersFromInstantMessageChannel(props.instantMessageChannelId, selectedIds);
            if (!result) return;
        }
        this.setState({
            selectedId: ""
        });
        props.onRemoved(selectedIds);
    };
    // #endregion Remove Users
    
    // #region Add Users
    handleAdd = () => {
        this.setState({
            showSelectUserDialog: true
        });
    };

    getAddSaveData = (instantMessageChannelId: string, userIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", instantMessageChannelId);
        result.append("userIds", userIds);
        return result;
    };

    addUsersToInstantMessageChannel = (instantMessageChannelId: string, userIds: string[], showSuccessMessage: boolean = true, disableLoadIndicator: boolean = false): Promise<InstantMessageChannelAddUsersSuccess> => {
        const saveData = this.getAddSaveData(instantMessageChannelId, userIds);
        return AppUtils.callService(() => instantMessageChannelService.instantMessageChannelEditAddUsers(saveData.obj), showSuccessMessage, disableLoadIndicator);
    };

    handleSelectUserDialogOk = async (users: IUserListItem[], companyId :string) => {
        const props = this.props;
        if (!users || users.length < 1) return;
        this.setState({
            showSelectUserDialog: false
        });
        // Call server
        let result: InstantMessageChannelAddUsersSuccess;
        if (!props.newChannelWizard) {
            result = await this.addUsersToInstantMessageChannel(props.instantMessageChannelId, users.map(i => i.id));
            if (!result) return;
        } else {
            result = new InstantMessageChannelAddUsersSuccess();
            result.addedUsers = users.map(i => InstantMessageChannelAddedUser.createInstantMessageChannelAddedUser(Base.getGuid(), i.id, InstantMessageChannelUserActiveState.Invited));
        }
        props.onAdded(companyId, users, result.addedUsers);
    };

    handleSelectUserDialogCancel = () => {
        this.setState({
            showSelectUserDialog: false
        });
    };

    handleLoadUsers = async (page: number, companyId: string): Promise<IEndlessList<UserListItem>> => {
        const props = this.props;
        let ignoreUserCodes = this.state.users.map(i => i.userCode);
        if (props.newChannelWizard) {
            ignoreUserCodes = ignoreUserCodes.concat([props.user.userCode]);
        }
        return await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelGetSelectUserListItems(props.instantMessageChannelCompanyId, props.instantMessageChannelId, companyId, page, ignoreUserCodes));
    };
    // #endregion Add Users

    handleLineLongPress = (id: string) => {
        this.setState({
            selectedId: id,
            showListMenu: true
        });
    };

    handleMenuRemove = () => {
        this.handleRemove();
        this.setState({
            showListMenu: false
        });
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const users = state.users;
        const externalChannel = props.companies && props.companies.length > 1;
        return (
            <div>
                {!props.isReadOnly &&
                    <div className="fullLeft">
                        <ToolButton
                            tooltip={Translations.Add}
                            classes={"round right mono add"}
                            onClick={this.handleAdd}/>
                    </div>
                }
                <InstantMessageChannelUserListTitleRow
                    newChannelUserList={!!props.newChannelWizard}
                />
                {users.length > 0 &&
                    <div className="fullLeft lineContainer intantMessageChannelUsers">
                        {props.companies.map((company) => {
                            const companyUsers = externalChannel
                                ? users.filter(i => i.companyId === company.id)
                                : users;
                            if (companyUsers.length > 0) {
                                return <div key={company.id}>
                                    {externalChannel &&
                                        <InstantMessageChannelUserListCompanyLine
                                            company={company}
                                        />
                                    }
                                    {companyUsers.map((user) =>
                                        <InstantMessageChannelUserListLine
                                            key={user.id}
                                            instantMessageChannelCompanyId={props.instantMessageChannelCompanyId}
                                            isReadOnly={props.isReadOnly}
                                            newChannelWizard={props.newChannelWizard}
                                            selectedId={state.selectedId}
                                            user={user}
                                            externalChannel={externalChannel}
                                            onClick={this.handleLineClick}
                                            onLongPress={!props.isReadOnly ? this.handleLineLongPress : null}
                                            onSetUserType={this.handleSetUserType}
                                        />
                                    )}
                                </div>;
                            } else {
                                return null;
                            }
                        })}
                    </div>
                }
                {state.showListMenu &&
                    <InstantMessageChannelUserListMenu
                        onRemove={this.handleMenuRemove}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {state.showSelectUserDialog &&
                    <SelectUserDialog
                        title={Translations.InviteInstantMessageChannelUser}
                        companies={props.companies}
                        loadUsers={this.handleLoadUsers}
                        multiSelect={true}
                        onOk={this.handleSelectUserDialogOk}
                        onCancel={this.handleSelectUserDialogCancel}
                    />
                }
            </div>
        );
    }
}